var map = {
	"./+forgot/forgot.module": [
		"../../../../../src/app/+auth/+forgot/forgot.module.ts",
		"forgot.module"
	],
	"./+locked/locked.module": [
		"../../../../../src/app/+auth/+locked/locked.module.ts",
		"common",
		"locked.module"
	],
	"./+login/login.module": [
		"../../../../../src/app/+auth/+login/login.module.ts",
		"login.module"
	],
	"./+register/register.module": [
		"../../../../../src/app/+auth/+register/register.module.ts",
		"register.module"
	],
	"./agendar-cita/agendar-cita.module": [
		"../../../../../src/app/+cita/agendar-cita/agendar-cita.module.ts",
		"common",
		"agendar-cita.module"
	],
	"./aseguradoras/aseguradoras.module": [
		"../../../../../src/app/+catalogo/aseguradoras/aseguradoras.module.ts",
		"common"
	],
	"./beneficiarios/beneficiarios.module": [
		"../../../../../src/app/+catalogo/beneficiarios/beneficiarios.module.ts",
		"common"
	],
	"./cargo-interno/cargo-interno.module": [
		"../../../../../src/app/+compras/cargo-interno/cargo-interno.module.ts",
		"common",
		"cargo-interno.module"
	],
	"./clientes/clientes.module": [
		"../../../../../src/app/+catalogo/clientes/clientes.module.ts",
		"common"
	],
	"./cotizacion/compras-cotizacion.module": [
		"../../../../../src/app/+compras/cotizacion/compras-cotizacion.module.ts",
		"common",
		"compras-cotizacion.module"
	],
	"./editar-autorizacion/editar-autorizacion.module": [
		"../../../../../src/app/+autorizacion/editar-autorizacion/editar-autorizacion.module.ts",
		"common",
		"editar-autorizacion.module"
	],
	"./editar-cotizacion/editar-cotizacion.module": [
		"../../../../../src/app/+cotizacion/editar-cotizacion/editar-cotizacion.module.ts",
		"common",
		"editar-cotizacion.module"
	],
	"./editar-entrega/editar-entrega.module": [
		"../../../../../src/app/+entrega/editar-entrega/editar-entrega.module.ts",
		"common",
		"editar-entrega.module"
	],
	"./editar-plan-trabajo/editar-plan-trabajo.module": [
		"../../../../../src/app/+plan-trabajo/editar-plan-trabajo/editar-plan-trabajo.module.ts",
		"common",
		"editar-plan-trabajo.module"
	],
	"./editar-presupuesto/editar-presupuesto.module": [
		"../../../../../src/app/+presupuesto/editar-presupuesto/editar-presupuesto.module.ts",
		"common",
		"editar-presupuesto.module"
	],
	"./editar-reparacion/editar-reparacion.module": [
		"../../../../../src/app/+reparacion/editar-reparacion/editar-reparacion.module.ts",
		"editar-reparacion.module",
		"common"
	],
	"./editar-terminada/editar-terminada.module": [
		"../../../../../src/app/+terminada/editar-terminada/editar-terminada.module.ts",
		"common",
		"editar-terminada.module"
	],
	"./editar-valuacion/editar-valuacion.module": [
		"../../../../../src/app/+valuacion/editar-valuacion/editar-valuacion.module.ts",
		"common",
		"editar-valuacion.module"
	],
	"./efectivo-reembolsable/efectivo-reembolsable.module": [
		"../../../../../src/app/+compras/efectivo-reembolsable/efectivo-reembolsable.module.ts",
		"common",
		"efectivo-reembolsable.module"
	],
	"./empleados/empleados.module": [
		"../../../../../src/app/+catalogo/empleados/empleados.module.ts",
		"common",
		"empleados.module"
	],
	"./facturas/facturas-registradas.module": [
		"../../../../../src/app/+compras/facturas/facturas-registradas.module.ts",
		"common",
		"facturas-registradas.module"
	],
	"./inventario/inventario.module": [
		"../../../../../src/app/+almacen/inventario/inventario.module.ts",
		"common",
		"inventario.module.0"
	],
	"./listar-os/listar-os.module": [
		"../../../../../src/app/+orden-servicio/listar-os/listar-os.module.ts",
		"common",
		"listar-os.module"
	],
	"./marcas/marcas.module": [
		"../../../../../src/app/+catalogo/marcas/marcas.module.ts",
		"common"
	],
	"./orden-servicio/orden-servicio.module": [
		"../../../../../src/app/+recepcion/orden-servicio/orden-servicio.module.ts",
		"common",
		"orden-servicio.module"
	],
	"./proceso-compra/proceso-compra.module": [
		"../../../../../src/app/+compras/proceso-compra/proceso-compra.module.ts",
		"common",
		"proceso-compra.module"
	],
	"./proveedores/proveedores.module": [
		"../../../../../src/app/+catalogo/proveedores/proveedores.module.ts",
		"common"
	],
	"./proveedoresCredito/proveedores-credito.module": [
		"../../../../../src/app/+pago/proveedoresCredito/proveedores-credito.module.ts",
		"common",
		"proveedores-credito.module"
	],
	"./recepcion-unidad/recepcion-unidad.module": [
		"../../../../../src/app/+recepcion/recepcion-unidad/recepcion-unidad.module.ts",
		"common",
		"recepcion-unidad.module"
	],
	"./refacciones/refacciones.module": [
		"../../../../../src/app/+almacen/refacciones/refacciones.module.ts",
		"common",
		"refacciones.module"
	],
	"./roles/roles.module": [
		"../../../../../src/app/+administracion/roles/roles.module.ts",
		"common",
		"roles.module"
	],
	"./timeline/timeline.module": [
		"../../../../../src/app/+orden-servicio/timeline/timeline.module.ts",
		"common",
		"timeline.module"
	],
	"app/+administracion/administracion.module": [
		"../../../../../src/app/+administracion/administracion.module.ts",
		"common",
		"administracion.module"
	],
	"app/+almacen/almacen.module": [
		"../../../../../src/app/+almacen/almacen.module.ts",
		"common",
		"almacen.module"
	],
	"app/+auth/auth.module": [
		"../../../../../src/app/+auth/auth.module.ts",
		"auth.module"
	],
	"app/+autorizacion/autorizacion.module": [
		"../../../../../src/app/+autorizacion/autorizacion.module.ts",
		"common",
		"autorizacion.module"
	],
	"app/+catalogo/catalogo.module": [
		"../../../../../src/app/+catalogo/catalogo.module.ts",
		"common"
	],
	"app/+cita/cita.module": [
		"../../../../../src/app/+cita/cita.module.ts",
		"common",
		"cita.module"
	],
	"app/+compras/compras.module": [
		"../../../../../src/app/+compras/compras.module.ts",
		"common",
		"compras.module"
	],
	"app/+cotizacion/cotizacion.module": [
		"../../../../../src/app/+cotizacion/cotizacion.module.ts",
		"common",
		"cotizacion.module"
	],
	"app/+dashboard/dashboard.module": [
		"../../../../../src/app/+dashboard/dashboard.module.ts",
		"common",
		"dashboard.module"
	],
	"app/+entrega/entrega.module": [
		"../../../../../src/app/+entrega/entrega.module.ts",
		"common",
		"entrega.module"
	],
	"app/+existencias/existencias.module": [
		"../../../../../src/app/+existencias/existencias.module.ts",
		"common",
		"existencias.module"
	],
	"app/+facturacion/cobranza/cobranza.module": [
		"../../../../../src/app/+facturacion/cobranza/cobranza.module.ts",
		"common",
		"cobranza.module"
	],
	"app/+facturacion/facturacion.module": [
		"../../../../../src/app/+facturacion/facturacion.module.ts",
		"common",
		"facturacion.module"
	],
	"app/+facturacion/facturar/facturar.module": [
		"../../../../../src/app/+facturacion/facturar/facturar.module.ts",
		"common",
		"facturar.module"
	],
	"app/+home/home.module": [
		"../../../../../src/app/+home/home.module.ts",
		"common",
		"home.module"
	],
	"app/+inventario/inventario.module": [
		"../../../../../src/app/+inventario/inventario.module.ts",
		"common",
		"inventario.module"
	],
	"app/+orden-servicio/orden-servicio.module": [
		"../../../../../src/app/+orden-servicio/orden-servicio.module.ts",
		"common",
		"orden-servicio.module.0"
	],
	"app/+pago/cuentasxPagar/cuentas-x-pagar.module": [
		"../../../../../src/app/+pago/cuentasxPagar/cuentas-x-pagar.module.ts",
		"common",
		"cuentas-x-pagar.module"
	],
	"app/+pago/facturas/facturas.module": [
		"../../../../../src/app/+pago/facturas/facturas.module.ts",
		"common",
		"facturas.module"
	],
	"app/+pago/pago.module": [
		"../../../../../src/app/+pago/pago.module.ts",
		"common",
		"pago.module"
	],
	"app/+password/password.module": [
		"../../../../../src/app/+password/password.module.ts",
		"common",
		"password.module"
	],
	"app/+plan-trabajo/plan-trabajo.module": [
		"../../../../../src/app/+plan-trabajo/plan-trabajo.module.ts",
		"common",
		"plan-trabajo.module"
	],
	"app/+presupuesto/presupuesto.module": [
		"../../../../../src/app/+presupuesto/presupuesto.module.ts",
		"common",
		"presupuesto.module"
	],
	"app/+recepcion/recepcion.module": [
		"../../../../../src/app/+recepcion/recepcion.module.ts",
		"common",
		"recepcion.module"
	],
	"app/+reparacion/reparacion.module": [
		"../../../../../src/app/+reparacion/reparacion.module.ts",
		"common",
		"reparacion.module"
	],
	"app/+reportes/reportes.module": [
		"../../../../../src/app/+reportes/reportes.module.ts",
		"common",
		"reportes.module"
	],
	"app/+terminada/terminada.module": [
		"../../../../../src/app/+terminada/terminada.module.ts",
		"common",
		"terminada.module"
	],
	"app/+valuacion/valuacion.module": [
		"../../../../../src/app/+valuacion/valuacion.module.ts",
		"common",
		"valuacion.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main